const defaultTemplates = [];

export default defaultTemplates;
